export default __webpack_public_path__ + "static/media/dark.4e9a7b9a.svg";